export const getMoveMailBodyTemplate = (
  folderId: string,
  mailId: string,
) => `<MoveItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">
      <ToFolderId>
        <t:DistinguishedFolderId Id="${folderId}" />
      </ToFolderId>
      <ItemIds>
        <t:ItemId Id="${mailId}" />
      </ItemIds>
    </MoveItem>
`;
